/** Named contact moments on the authored rally clock. */
export function checkpoints(weServe:boolean,attackOnly=false){
 const all=weServe?[
  {at:1.65,he:'סרב',en:'Serve'}, {at:3.15,he:'קבלת היריבה',en:'Opponent pass'},
  {at:4.25,he:'מסירת היריבה',en:'Opponent set'}, {at:5.25,he:'התקפת היריבה',en:'Opponent attack'},
  {at:6.15,he:'הגנה',en:'Dig'}, {at:7.25,he:'מסירה',en:'Set'}, {at:8.25,he:'התקפה',en:'Attack'}
 ]:[{at:1.65,he:'סרב היריבה',en:'Opponent serve'},{at:3.15,he:'קבלה',en:'Pass'},{at:4.25,he:'מסירה',en:'Set'},{at:5.25,he:'התקפה',en:'Attack'}];
 return attackOnly?all.filter(p=>p.at>=4.25):all;
}
